import React from 'react';
import PropTypes from 'prop-types';
import Price from '../../Price';

export default class CustomPageDetailContentEcModalItem extends React.Component {

  static propTypes = {
    pageBlockItem: PropTypes.any.isRequired
  };

  render() {
    let pageBlockItem = this.props.pageBlockItem;

    let itemPreviewImageUrlList = Array.isArray(pageBlockItem.itemPreviewImageUrls)?pageBlockItem.itemPreviewImageUrls.map(function(itemPreviewImageUrl, i){
      return <li key={i}><figure className="img"><span><img className="m_imgShadow" src={itemPreviewImageUrl}/></span></figure></li>
    }):undefined;

    let itemPreviewImageUrlListMobile = Array.isArray(pageBlockItem.itemPreviewImageUrls)?pageBlockItem.itemPreviewImageUrls.map(function(itemPreviewImageUrl, i){
      return <li key={i} className="thumbnail-item" data-index={i}><img src={itemPreviewImageUrl} width="53"/></li>
    }):undefined;

    return (
      <div className="modal fade" id={`item_modal_${pageBlockItem.pageBlockItemId}`} tabIndex="-1" role="dialog"
           aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="myLargeModalLabel">商品プレビュー</h3>
              <button className="close" type="button" data-dismiss="modal"><span aria-hidden="true">×</span><span
                className="sr-only">閉じる</span></button>
            </div>

            <div className="modal-body">
              <div className="m_box2col">
                <div className="col slideCol">
                  <div className="m_itemSlides js_slider">
                    <ul>
                      {itemPreviewImageUrlList}
                    </ul>
                  </div>
                  <ul className="m_slideTmb js_slidesTmb">
                    {itemPreviewImageUrlListMobile}
                  </ul>
                </div>
                <div className="col">
                  <h4 className="ttl">{pageBlockItem.itemName}</h4>
                  <dl className="pdtInfo">
                    <dt>メーカー</dt>
                    <dd><a href={pageBlockItem.itemCompanyUrl}>{pageBlockItem.itemCompanyName}</a></dd>
                    {pageBlockItem.extendProperties.seriesName &&
                      <React.Fragment>
                        <dt>シリーズ</dt>
                        <dd>{pageBlockItem.extendProperties.seriesName}</dd>
                      </React.Fragment>
                    }
                    {pageBlockItem.extendProperties.modelName &&
                      <React.Fragment>
                        <dt>型式</dt>
                        <dd>{pageBlockItem.extendProperties.modelName}</dd>
                      </React.Fragment>
                    }
                    <dt>価格</dt>
                    <dd className="price">
                      <span className="m_txt s_notice">
                        <span className="fwb">¥13,710
                        </span>
                      </span>
                    </dd>
                  </dl>
                  <p className="subTxt"><span className="m_txt s_active fwb">在庫あり</span> <span
                    className="notes">（559点の在庫）</span></p>
                  <p className="subTxt">東京都北区までの送料：¥2,500、海外発送あり</p>
                  <p className="subTxt">{"この商品は、{ショップ名}が販売、配送します。"}</p>
                  <ul className="labelWrap">
                    <li className="label"><i className="fa fa-circle"></i>新規取扱製品</li>
                    <li className="label"><i className="fa fa-circle"></i>取扱終了製品</li>
                    <li className="label">デモ・レンタルあり</li>
                    <li className="label">受注生産</li>
                    <li className="label">カスタマイズ品</li>
                  </ul>
                  <div className="m_accWrap js_readmore" data-more="カタログ説明文を全部表示 &amp;#xf067;"
                       data-less="カタログ説明文を閉じる &amp;#xf068;">
                    <div className="accInner js_readmoreTarget">
                      <p
                        className="subTxt">{pageBlockItem.itemDescription}</p>
                    </div>
                  </div>
                  <div className="bdBox">
                    <div className="numCol"><span className="notes">数量：</span>
                      <select>
                        <option value="">3</option>
                      </select>
                    </div>
                    <p className="m_btn s_dl"><a><i className="c-fa-cart"></i> カートに入れる</a></p>
                    <p className="m_btn s_gray"><a>商品詳細を見る</a></p>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <div className="m_btn s_gray">
                <button className="txt" type="button" data-dismiss="modal" aria-hidden="true">閉じる</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
}
